import { useState, useEffect } from 'react';
import { getLang, saveLang } from '../utils/i18n';

export default function useLang() {
  const [lang, setLang] = useState(getLang);

  useEffect(() => {
    const onStorage = () => setLang(getLang());
    window.addEventListener('lang-change', onStorage);
    return () => window.removeEventListener('lang-change', onStorage);
  }, []);

  const changeLang = (code) => {
    saveLang(code);
    setLang(code);
    window.dispatchEvent(new Event('lang-change'));
  };

  return { lang, changeLang };
}
